
const EnvName={
    dev:"dev",
    test:"test",
    prod:"prod",
  }
  
const ProdHostName='www.medcircle.cn';
const ApiSocketPort=13771;
const ChatSocktPort=8093;
  function getEnvName()
  {
    const hostname = location.hostname;
    let weixin = {
      appId: null
    };
    
    // 生产环境
     if (hostname == ProdHostName) {
      return EnvName.prod
    }
    else {
      return EnvName.dev;
    }
  }
  
  function getWeixin() {
    var env=getEnvName();
    let weixin = {
      appId: null
    };
     // 测试
    if (env==EnvName.dev || env==EnvName.test) {
      weixin.appId = "wxa85c6276c57c60db"; // 医点通.top 测试环境
    } 
    // 生产环境
    else if (env==EnvName.prod) {
      weixin.appId = "wxe0bc80102afcd8bf"; // 
    }
    return weixin;
  }
  
  function getSocketPort() {
    const hostname = location.hostname;
    if (window.location.protocol === 'https:') {
      return 'https://cmdhra.medcircle.cn/'
    } else {
      return 'http://123.57.233.107:8093/';  // 
    }
  }

  function getNettyUrl() {
    var hostName= window.location.hostname;
    return `ws://${hostName}:${ApiSocketPort}/ws`;
  }
  
  // import AppSetting from '@/AppSetting'
  export default {
    getWeixin,
    getSocketPort,
    RouterBase: "cmdhra_pc", 
    baseUrl: "/ra-app/api",
    getNettyUrl,
  };
  


// WEBPACK FOOTER //
// ./src/AppSetting.js